import React, { memo, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import BookingFormStore from 'Stores/BookingFormStore';
import BookingRegisterButtons from 'Components/Front/Booking/BookingRegisterButtons';
import NewClientBookingInfo from 'Components/Front/Booking/NewClientBookingInfo';
import GuestBookingForm from 'Components/Front/Booking/GuestBookingForm';
import BookingRegistration from 'Components/Front/Booking/BookingRegistration';
import bemit from 'Functions/bemit';
import { isTrue } from 'Shared/utilities';

// colonne de droite dans la résa, permet de demander la création d'un compte
// ou de continuer en inviter
export default memo(function NewClientBookingFlow({
  ...props
}) {
  const continue_as_guest = BookingFormStore.useState(s => s.continue_as_guest);
  const oauth_register = BookingFormStore.useState(s => s.oauth_register);
  const create_account = BookingFormStore.useState(s => s.create_account);
  const is__auth = BookingFormStore.useState(s => s.logged_in);
  const step = BookingFormStore.useState(s => s.step);
  const continueAsGuest = useCallback(function (e) {
    const update = {
      continue_as_guest: true,
      create_account: false,
      oauth_register_error: undefined,
      oauth_strategy: undefined,
      oauth_register: false,
      warning: undefined,
      error: undefined,
      info: undefined
    };
    BookingFormStore.update(function (store) {
      Object.keys(update).forEach(field => store[field] = update[field]);
    });
  }, []);
  if (step !== 1 || is__auth || oauth_register) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "c-booking-auth__step"
  }, /*#__PURE__*/React.createElement(NewClientBookingInfo, null), continue_as_guest ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GuestBookingForm, {
    etablishment: props.etablishment,
    space: props.space
  }), /*#__PURE__*/React.createElement("div", {
    className: "c-separator c-separator--light\r u-margin-top-25 u-margin-bottom-25"
  }, "ou"), /*#__PURE__*/React.createElement(BookingRegisterButtons, null)) : create_account ? /*#__PURE__*/React.createElement("div", {
    className: "c-booking-auth__buttons"
  }, /*#__PURE__*/React.createElement(Button, {
    className: bemit('c-flat-btn', ['white']) + ' u-margin-bottom-0',
    onClick: continueAsGuest
  }, "Continuer en tant qu'invit\xE9"), /*#__PURE__*/React.createElement("div", {
    className: "c-separator c-separator--light\r u-margin-top-25 u-margin-bottom-25"
  }, "ou"), /*#__PURE__*/React.createElement(BookingRegistration, {
    etablishment: props.etablishment,
    space: props.space,
    "white-label-booking": props['white-label-booking']
  }), /*#__PURE__*/React.createElement("div", {
    className: "c-separator c-separator--light\r u-margin-top-25 u-margin-bottom-0"
  }, "ou"), /*#__PURE__*/React.createElement(BookingRegisterButtons, null)) : /*#__PURE__*/React.createElement("div", {
    className: "c-booking-auth__buttons"
  }, /*#__PURE__*/React.createElement(Button, {
    className: bemit('c-flat-btn', ['white']) + ' u-margin-bottom-0',
    onClick: continueAsGuest
  }, "Continuer en tant qu'invit\xE9"), /*#__PURE__*/React.createElement("div", {
    className: "c-separator c-separator--light\r u-margin-top-25 u-margin-bottom-25"
  }, "ou"), /*#__PURE__*/React.createElement(BookingRegisterButtons, null)));
});
